import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-top" }
const _hoisted_2 = { class: "w-context" }
const _hoisted_3 = {
  class: "w-screen-nav",
  "aria-label": "Разделы расписания"
}
const _hoisted_4 = ["aria-pressed"]
const _hoisted_5 = ["aria-pressed"]
const _hoisted_6 = {
  key: 0,
  class: "w-actions"
}
const _hoisted_7 = ["disabled"]

import { computed } from 'vue';
import { useScheduleStore } from '@/store/calendar/scheduleModule';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarHeader',
  setup(__props) {

const store = useScheduleStore();

const accessText = computed(() => {
  if (!store.canEdit) return 'просмотр';
  return store.mode === 'team' ? 'календарь сотрудника' : 'мой график';
});

const contextText = computed(() => (
  store.screen === 'branch'
    ? `${store.currentBranch?.name} · управление режимом работы`
    : `${store.staffDoctor?.name} · ${accessText.value}`
));

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-title-line" }, [
        _createElementVNode("h1", null, "Календарь приёма")
      ], -1)),
      _createElementVNode("p", _hoisted_2, _toDisplayString(contextText.value), 1)
    ]),
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("button", {
        type: "button",
        "aria-pressed": String(_unref(store).screen === 'calendar'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).setScreen('calendar')))
      }, [
        _createVNode(_component_q_icon, { name: "calendar_month" }),
        _cache[4] || (_cache[4] = _createTextVNode(" Календарь по дням ", -1))
      ], 8, _hoisted_4),
      (_unref(store).canManage)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            "aria-pressed": String(_unref(store).screen === 'branch'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).setScreen('branch')))
          }, [
            _createVNode(_component_q_icon, { name: "apartment" }),
            _cache[5] || (_cache[5] = _createTextVNode(" Режим филиала ", -1))
          ], 8, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    (_unref(store).screen === 'calendar')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "w-button primary",
            type: "button",
            disabled: !_unref(store).canPlan,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).toggleBuilder()))
          }, [
            _createVNode(_component_q_icon, { name: "add" }),
            _cache[6] || (_cache[6] = _createTextVNode(" Заполнить график ", -1))
          ], 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})